import styled, { css } from 'styled-components';

import omitProps from 'ggApp/utils/omitProps';
import Favorite from 'ggApp/shared/components/cards/favoriteButton';
import { ReviewIO as ReviewIOComponent } from 'ggApp/shared/components/ReviewIO';
import Share from 'ggApp/shared/components/cards/ProductDetailsCard/ShareProduct';

const Container = styled.div`
    align-self: start;
    top: 144px;
    z-index: 1;

    ${(props) => props.theme.superQuery.all.and.minHeight.of('860px').css`
        position: sticky;
    `}

    ${(props) => props.theme.superQuery.all.and.minWidth.tabletMin.css`
        margin-bottom: 32px;
    `}

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        position: initial;
    `}
`;

const Wrap = styled.div`
    padding: ${({ mixPDP }) => (mixPDP ? '0 0 24px' : '24px')};
    background: ${({ theme }) => theme.colors.ElementBackground};
    box-shadow: ${(props) =>
        props.mixPDP
            ? 'none'
            : `0px 7px 15px rgba(0, 0, 0, 0.13), 0px 0px 3px rgba(0, 0, 0, 0.05)`};
    border-radius: 8px;

    ${(props) => props.theme.superQuery.all.and.minWidth.desktopMin.css`
        padding: 24px;
    `}
`;

const ChipsBlock = styled.div`
    display: flex;
    margin-bottom: 16px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        grid-area: product-detail-card;
        margin-bottom: ${() => props.theme.spacers.XXL};
    `}
`;

const FavoriteButton = styled(Favorite)`
    float: right;
`;

const Name = styled.h1`
    ${({ theme }) => css(theme.typography.Subheadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-bottom: 16px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: 8px;
    `}
`;

const CoreAttributes = styled.div`
    ${({ theme }) => css(theme.typography.Paragraph)};
    margin-bottom: 16px;
    color: ${(props) =>
        props.mixPDP ? props.theme.colors['Level 4'] : props.theme.colors.Foreground};
`;

// isFirst - hack for heart animation
const ShareButton = styled(omitProps('isFirst')(Share))`
    float: right;
    clear: right;
    transform: translate(16px, -25px);
    width: 52px;
    ${({ isFirst }) => isFirst && 'margin-top: 12px'};
`;

const ReviewIO = styled(ReviewIOComponent)`
    margin-top: ${(props) => (props.mixPDP ? '0px' : '20px')};
    justify-content: center;
`;

export const LowInStock = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.negative};

    > *:first-child {
        margin-right: 16px;
        margin-left: 2px;
    }

    svg {
        width: 20px;
        height: 20px;
    }
`;

export { Container, Wrap, ChipsBlock, FavoriteButton, Name, CoreAttributes, ShareButton, ReviewIO };
